<template>
  <v-container fluid class="pa-0 mt-2" style:="height:100vh;">
    <div class="w-100 d-flex justify-space-between mb-5">
      <v-card class="pb-3 px-2 pt-0" elevation="0" outlined
        v-bind:class="{
            'w-50 mr-1': !$vuetify.breakpoint.smAndDown,
            'w-100': $vuetify.breakpoint.smAndDown,
          }">
            <SearchBar
              class="px-3 pt-0 "
              placeholder="mediaMode.searchBarPlaceholder"
              icon="person_add"
              :dataSet="dataSet"
              :navigate="false"
              :playersResults="5"
              :gamesResults="5"
              :showLeagues="false"
              :showTeams="false"
              :showMore="false"
              @resultClicked="onResultClicked($event)"
            ></SearchBar>
      </v-card>
      <v-card class="d-flex align-center pr-5 pt-1" style="position:relative;" v-if="activeElement" elevation="0" outlined
      v-bind:class="{
            'w-50 ml-1': !$vuetify.breakpoint.smAndDown,
            'w-100': $vuetify.breakpoint.smAndDown,
          }" v-bind:style="{height:`${SIZE_HEADER}px`}">
        <PlayerSearchItem class="w-100" :player="activeElement" v-if="activeElement && activeElement.elementType === 'player'" allowRouter></PlayerSearchItem>
        <GameSearchItem class="w-100" :game="activeElement" v-if="activeElement && activeElement.elementType === 'game'" allowRouter></GameSearchItem>
      </v-card>
    </div>
    <v-divider class="elevation-0 mb-5"></v-divider>
    <v-divider></v-divider>
    <div class="d-flex flex-column w-100" v-if="activeElement && activeElement.elementType === 'player'">
        <div class="d-flex flex-column" v-if="activeElement.playerDetail && activeElement.playerTeamSeasonData">
          <div class="rounded text-center pa-2 pt-3" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
            <span class="white--text header-font" style="font-size: 18px;">{{$t("playerDetail.performance")}}</span>
          </div>
          <PlayerRadar :playerId="activeElement.id" :radarId="0" class="" :headerPlayer="activeElement.playerDetail" 
          :headerPlayerSeasonData="activeElement.playerTeamSeasonData"></PlayerRadar>
        </div>
        <div class="d-flex flex-column" v-if="activeElement.playerDetail">
          <div class="rounded text-center pa-2 pt-3 mb-13" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
            <span class="white--text header-font" style="font-size: 18px;">{{$t("playerDetail.finishingMap")}}</span>
          </div>
          <PlayerFinishingMap :playerId="activeElement.id" :chartId="1" class="" :headerPlayer="activeElement.playerDetail"></PlayerFinishingMap>
        </div>
        <div class="d-flex flex-column" v-if="activeElement.playerDetail">
          <div class="rounded text-center pa-2 pt-3 mb-13" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
            <span class="white--text header-font" style="font-size: 18px;">{{$t("playerDetail.keyPassMap")}}</span>
          </div>
          <PlayerKeyPassMap :playerId="activeElement.id" :chartId="2" :headerPlayer="activeElement.playerDetail"></PlayerKeyPassMap>
        </div>
        <div class="d-flex flex-column" v-if="activeElement.playerDetail">
          <div class="rounded text-center pa-2 pt-3 mb-13" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
            <span class="white--text header-font" style="font-size: 18px;">{{$t("playerDetail.threatMap")}}</span>
          </div>
          <PlayerThreat :playerId="activeElement.id" :chartId="1" class="" :headerPlayer="activeElement.playerDetail"></PlayerThreat>
        </div>
        <div class="d-flex flex-column">
          <div class="rounded text-center pa-2 pt-3" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
            <span class="white--text header-font" style="font-size: 18px;">{{$t("playerDetail.analysis")}}</span>
          </div>
          <PlayerAnalysis :player="activeElement"></PlayerAnalysis>
        </div>
        <div class="d-flex flex-column" v-if="activeElement.playerDetail">
          <div class="rounded text-center pa-2 pt-3" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
            <span class="white--text header-font" style="font-size: 18px;">{{$t("playerDetail.beeswarm")}}</span>
          </div>
          <PlayerBeeswarm :playerId="activeElement.id" :headerPlayer="activeElement.playerDetail"></PlayerBeeswarm>
        </div>
    </div>
    <div class="d-flex flex-column w-100" v-if="activeElement && activeElement.elementType === 'game'" style=""
    >
      <div class="d-flex flex-column">
        <div class="rounded text-center pa-2 pt-3 mb-13" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
          <span class="white--text header-font" style="font-size: 18px;">{{$t("playerDetail.finishingMap")}}</span>
        </div>
        <GameFinishingMap :gameId="activeElement.id" class="" :chartId="0"></GameFinishingMap>
      </div>
      <div class="d-flex flex-column">
        <div class="rounded text-center pa-2 pt-3 mb-13" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
          <span class="white--text header-font" style="font-size: 18px;">{{$t("playerDetail.keyPassMap")}}</span>
        </div>
        <GameKeyPassMap :gameId="activeElement.id" :chartId="1"></GameKeyPassMap>
      </div>
      <div class="d-flex flex-column">
        <div class="rounded text-center pa-2 pt-3 mb-3" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
          <span class="white--text header-font" style="font-size: 18px;">{{$t("game.header.gamePassMap")}}</span>
        </div>
        <GamePassMap :gameId="activeElement.id" :chartId="2" showCardFilter></GamePassMap>
      </div>
      <div class="d-flex flex-column">
        <div class="rounded text-center pa-2 pt-3" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
          <span class="white--text header-font" style="font-size: 18px;">{{$t("game.header.gameFlow")}}</span>
        </div>
        <GameFlow :gameId="activeElement.id" :chartId="3"></GameFlow>
      </div>
      <div class="d-flex flex-column">
        <div class="rounded text-center pa-2 pt-3 mb-13" :class="$vuetify.theme.dark ? 'secondary' : 'primary'">
          <span class="white--text header-font" style="font-size: 18px;">{{$t("game.header.gameThreat")}}</span>
        </div>
        <GameThreat :gameId="activeElement.id" :chartId="4"></GameThreat>
      </div>
    </div>
  </v-container>
</template>

<script>
import * as _ from 'lodash';
import SearchBar from '../base/SearchBar';
import GameService from "../../services/game/game.service";
import GameFinishingMap from '../game/GameFinishingMap';
import GameKeyPassMap from '../game/GameKeyPassMap';
import GamePassMap from '../game/GamePassMap';
import GameFlow from '../game/GameFlow';
import GameThreat from '../game/GameThreat';
import GameSearchItem from '../game/GameSearchItem';

import PlayerService from "../../services/player/player.service";
import PlayerFinishingMap from '../player/PlayerFinishingMap';
import PlayerKeyPassMap from '../player/PlayerKeyPassMap';
import PlayerRadar from '../player/PlayerRadar';
import PlayerThreat from '../player/PlayerThreat';
import PlayerBeeswarm from '../player/PlayerBeeswarm';
import PlayerSearchItem from '../player/PlayerSearchItem';
import PlayerAnalysis from '../player/PlayerAnalysis';

export default {
  name: "MediaDashboard",
  props: {},
  components: {
    GameFinishingMap,
    GameKeyPassMap,
    GamePassMap,
    GameFlow,
    GameThreat,
    GameSearchItem,
    PlayerRadar,
    PlayerFinishingMap,
    PlayerKeyPassMap,
    PlayerThreat,
    PlayerBeeswarm,
    PlayerSearchItem,
    PlayerAnalysis,
    SearchBar
  },
  data() {
    return {
      OUTSIDE_PADDING: 12,
      SIZE_HEADER: 60,
      activeElement: null,
      dataSet: null,
      loading: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  watch: {
    "$store.state.search.dataSetChange": async function (newValue, oldValue) {
      await this.loadDataSet();
      if(this.dataSet){
        this.activeElement = _.find(this.dataSet.games,(g) => g.id === this.activeElement.id || g.id === this.activeElement.gameId);
        this.activeElement.elementType = 'game';
      }
      this.$forceUpdate();
    },
  },
  async mounted() {
    if (this.currentUser.league && this.currentUser.league.id) {
      await this.loadViewData();
    };
  },
  methods: {
    async loadViewData() {
      let gameResponse = await GameService.getLatestGamesPlayedInLeague(this.currentUser.league.id,3);
      this.activeElement = _.sample(gameResponse.data);
      this.activeElement.id = this.activeElement.gameId;
      await this.loadDataSet();
      if(this.dataSet){
        this.activeElement = _.find(this.dataSet.games,(g) => g.id === this.activeElement.id || g.id === this.activeElement.gameId);
        if(!this.activeElement){
          this.activeElement = _.sample(this.dataSet.games);
        }
        this.activeElement.elementType = 'game';
      }
    },
    onResultClicked(event){
      this.activeElement = null;
      setTimeout(async () => {
        this.activeElement = event.value;
        this.activeElement.teamId = this.activeElement.tId;
        this.activeElement.elementType = event.type;
        if(event.type === 'player'){
          let responses = await Promise.all([PlayerService.getPlayer(event.id),
          PlayerService.getPlayerTeamSeasonData(event.id,this.currentUser.clientId)]);
          this.activeElement.playerDetail = responses[0].data;
          this.activeElement.playerTeamSeasonData = responses[1].data;
          this.$forceUpdate();
        }
      },5)
    },
    loadDataSet: async function () {
      this.dataSet = await this.$store.dispatch("getDataSet");
    },
  },
  beforeDestroy(){
    setTimeout(() => {
      this.dataSet = [];
      this.$forceUpdate();
    },1)
  },
  destroyed(){
    this.dataSet = [];
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/MediaDashboard.vue